import controller from './bill-info-add.controller';

export default {
  bindings: {
    invoice: '<',
    packet: '<',
    bill: '@',
    promocode: '='
  },
  controller,
  template: require('./bill-info-add.html')
};



// WEBPACK FOOTER //
// src/app/buy/bill-info/add/bill-info-add.component.ts